export const CREATE_DMX_CONTROLLER = 'CREATE_DMX_CONTROLLER';
export const CREATE_DMX_CONTROLLER_SUCCESSFUL = 'CREATE_DMX_CONTROLLER_SUCCESSFUL';
export const CREATE_DMX_CONTROLLER_FAILED = 'CREATE_DMX_CONTROLLER_FAILED';
